import React from 'react';
import ReactDOM from 'react-dom';
import "assets/css/material-dashboard-pro-react.css?v=1.4.0";
import "assets/css/add-to-homescreen.css";
import App from './App';
//import * as serviceWorker from './serviceWorker';
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();

//const SwConfig = { onUpdate: console.log('Eine neue Version der App, falls verfügbar, wird jetzt abgerufen!') } /*this.props.enqueueSnackbar*/
registerServiceWorker();
